<template>
  <div id="rg-date-input-dialog">
    <vs-prompt
      class="rg-date-input"
      title="再生履歴の日時設定"
      accept-text="設定"
      cancel-text="キャンセル"
      :active="active"
      is-valid="true"
      @accept="onAccept"
      @cancel="onCancel"
    >
      <div class="input-form">
        <div class="rg-date-time-input-notes aisea-text-12-400-gray">
          指定した日時の前後1時間の履歴を表示します。
        </div>
        <div class="date-time-input">
          <v-date-picker
            v-model="inputDatetime"
            :min-date="minDate"
            :max-date="maxDate"
            :minute-increment="10"
            mode="dateTime"
            :masks="masks"
            is-required
            is-expanded
            is24hr
          />
        </div>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import moment from "moment-timezone";
import { createNamespacedHelpers } from "vuex";

const {
  mapGetters: mapGettersOfRGPlayback,
  mapMutations: mapMutationsOfRGPlayback,
} = createNamespacedHelpers("radarGridPlayback");
const createOneHourAgoDateCalculator = () => {
  const momentNow = moment(); // createOneHourAgoDateCalculatorの呼び出し時の日時を基準にする
  return () => {
    return moment({
      year: momentNow.year(),
      month: momentNow.month(),
      day: momentNow.date(),
      hour: momentNow.hours(),
      minute: momentNow.minutes(),
    })
      .subtract(1, "hours")
      .toDate();
  };
};
const oneHourAgoDateCalculator = createOneHourAgoDateCalculator();
const EMIT_EVENTS = {
  CANCEL: "cancel",
};
export default {
  name: "RgDateInputDialog",
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      minDate: moment({
        year: 2023,
        month: 4,
        day: 1,
        hour: 0,
        minute: 0,
      }).toDate(),
      maxDate: oneHourAgoDateCalculator(),
      inputDatetime: oneHourAgoDateCalculator(),
      masks: {
        title: "YYYY年 MMM",
      },
    };
  },
  watch: {
    active(val) {
      if (val) {
        const { baseTime } = this.playbackSettings;
        if (baseTime) {
          this.inputDatetime = new Date(baseTime * 1000);
        }
      }
    },
  },
  computed: {
    ...mapGettersOfRGPlayback(["isInitial", "playbackSettings"]),
  },
  methods: {
    ...mapMutationsOfRGPlayback(["SET_IS_ACTIVE_DATE_INPUT_DIALOG"]),
    onAccept() {
      setTimeout(() => {
        this.$emit("sendInputValue", this.inputDatetime);
        this.SET_IS_ACTIVE_DATE_INPUT_DIALOG(false);
      });
    },
    onCancel() {
      if (this.isInitial) {
        this.$router.push({ name: "enterprise-live-map" });
      }
      setTimeout(() => {
        this.$emit(EMIT_EVENTS.CANCEL);
        this.SET_IS_ACTIVE_DATE_INPUT_DIALOG(false);
      });
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";

.rg-date-input {
  .vs-con-input-label {
    width: inherit;
  }

  .rg-date-time-input-notes {
    margin-bottom: 20px;
  }

  .vs-dialog-cancel {
    display: none;
  }
}
</style>
